import { Alert, Button, Card, Checkbox, Form, Input, Select, TreeSelect } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useUser } from 'src/context/UserContext'
import { getIabCategoriesAsTree, isAdmin, isAgencyAdmin } from 'src/util/Util'
import { CountryBean, MediaAgencyBean } from '../../../api/api'
import { formDataLoader, FormDataType } from '../../../util/FormDataLoader'
import advertiserApi from './AdvertiserApi'

const FormItem = Form.Item
const Option = Select.Option

interface Props { }

const AdvertiserEdit: React.FC<Props> = () => {

    const formInfoItems: FormDataType[] = [
        FormDataType.Countries,
        FormDataType.IabCategories
    ]

    const { user } = useUser()

    const [info, setInfo] = useState({
        countries: [],
        mediaAgencies: [],
        iabCategories: []
    })

    const [form] = useForm()
    const [error, setError] = useState()
    const { id } = useParams<{ id: string }>()
    const navigateTo = useNavigate()

    const admin = isAdmin(user)
    const agencyAdmin = isAgencyAdmin(user)

    const loadData = async () => {
        try {
            const response = await advertiserApi.view(id)
            form.setFieldsValue(response.data)

            if (admin || agencyAdmin) formInfoItems.push(FormDataType.MediaAgencies)

            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await advertiserApi.edit(id, values)
            navigateTo('/advertiser')
        } catch (e) {
            setError(e.error)
        }
    }

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error ? <Alert message={error} type="error" /> : null}
        <Card title="Advertiser" size="small" className="form-card">
            <FormItem
                required
                name="mediaAgencyId"
                label="Media Agency"
            >
                <Select
                    showSearch
                    allowClear
                    optionFilterProp="title"
                    placeholder="Select Media Agency"
                >
                    {(admin || agencyAdmin) && info.mediaAgencies.map((item: MediaAgencyBean) =>
                        <Option title={item.name} key={item.id} value={item.id as number}>{item.name}</Option>
                    )}
                </Select>
            </FormItem>
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input placeholder="Name" />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue="true"
                required
            >
                <Checkbox />
            </FormItem>
            <FormItem
                required
                name="countryId"
                label="Country"
            >
                <Select
                    showSearch
                    allowClear
                    optionFilterProp="title"
                    placeholder="Select country"
                >
                    {info.countries.map((item: CountryBean) =>
                        <Option title={item.name} key={item.code} value={item.code}>{item.name}</Option>
                    )}
                </Select>
            </FormItem>
            <FormItem
                name="description"
                label="Description"
            >
                <Input placeholder="Description" />
            </FormItem>
            <FormItem
                name="domain"
                label="Domain"
            >
                <Input placeholder="Domain" />
            </FormItem>
                        <FormItem
                name="iabCategoryIds"
                label="IAB Categories"
            >
                <TreeSelect
                    allowClear
                    treeCheckable
                    showCheckedStrategy="SHOW_ALL"
                    placeholder="Select IAB categories"
                    treeData={getIabCategoriesAsTree(info.iabCategories)}
                />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Save</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/advertiser')}>Cancel</Button>
        </div>
    </Form>
}

export default AdvertiserEdit


// WEBPACK FOOTER //
// ./src/component/app/advertiser/AdvertiserEdit.tsx